import { useRecoilValue, useSetRecoilState } from "recoil"

import useMeetingClient from "../useMeetingClient"
import useIncomingRTCAudio from "./useIncomingRTCAudio"
import { waitForElementForPeriod } from "../../util/waitForElm"
import { localUserCallbackSelector } from "../../recoil/atoms/users"
import { useCallback, useRef } from "react"
import { playerPropsSelector } from "../../recoil/atoms/player"
import { usePictureInPicture } from "../usePictureInPicture"

const useMuteAndPauseAllMedia = () => {
  const isLocalAudioMutedRef = useRef(false)
  
  const meetingClient = useMeetingClient()
  const { exitPictureInPicture } = usePictureInPicture()
  const localUserCallbackProps = useRecoilValue(localUserCallbackSelector)
  const { muteRTCIncomingAudio, unmuteRTCIncomingAudio } = useIncomingRTCAudio()
  const setPlayerProps = useSetRecoilState(playerPropsSelector)

  /** This method will do following thing
   *  1. Turn off mic, cam and screen-share
   *  2. Mute all other participates incoming audio.
   *  3. Pause MNP and watchparty audio and video
   */
  const muteAndPauseAllMedia = useCallback(async () => {
    isLocalAudioMutedRef.current = true
    const localUser = await localUserCallbackProps.handleReturnData()

    // 1. Turn off mic, cam and screen-share
    if (localUser.micEnabled) {
      meetingClient?.toggleMic(localUser.micEnabled)
    }
    if (localUser.camEnabled) {
      meetingClient?.toggleCam(localUser.camEnabled)
    }
    if (localUser.screenShareEnabled) {
      meetingClient?.toggleScreenShare(
        localUser.screenShareEnabled,
        localUser.id
      )
    }

    // Exit PIP video
    exitPictureInPicture()

    // 2. Mute all other participates incoming audio.
    muteRTCIncomingAudio()

    setPlayerProps({
      paused: true
    })

  }, [localUserCallbackProps, meetingClient, muteRTCIncomingAudio, setPlayerProps])


  /** Unmute the incoming media */
  const unmuteMedia = useCallback(() => {

    // If incoming audio is already unmuted, then return
    if(isLocalAudioMutedRef.current === false) return 
    isLocalAudioMutedRef.current = false
    // Unmute incoming Audio
    unmuteRTCIncomingAudio()
  }, [unmuteRTCIncomingAudio])

  return { muteAndPauseAllMedia, unmuteMedia, isLocalAudioMuted: isLocalAudioMutedRef.current }
}

export default useMuteAndPauseAllMedia
